<template>
  <div class="side-wrap">
    <div class="title-wrap">
      <!-- <a-icon type="global" /> -->
      <img class="icon-img" src="/static/iconHot.png" alt="" />
      <span class="title">热点专利</span>
    </div>
    <div class="side-body-wrap">
      <MediaWrap
        :url="item.picture"
        :width="180"
        :height="180"
        v-for="item in hotlist"
        :key="item.id"
        @click.native="toDetail(item.id)"
      ></MediaWrap>
    </div>
  </div>
</template>

<script>
import { getLincenceHotInfo, viewLincenceResultInfo } from '@/api/tradingInfos.js'

export default {
  data() {
    return {
      hotlist: []
    }
  },
  components: {},
  async created() {
    const { data } = await getLincenceHotInfo()
    this.hotlist = data
  },
  methods: {
    async toDetail(id) {
      this.$router.push({ name: 'licenseDetailDeal', query: { id } })
      await viewLincenceResultInfo(id)
    }
  }
}
</script>
